/// <reference path="../types/index.d.ts" />

import '../client_forms/thecateredaffair1bpl/style.css';
import FormStructure from './thecateredaffair1bpl/form_structure';

export default FormStructure;